// 为了兼容一个接口
import fetch from "./index";

export function itemStatusHttpAction(param) {
  return fetch({
    url:"/api/companystaff/individualBusiness/checkIndividualBusinessStatus/" +param,
    method: "get",
  });
}
